import { render } from "./WaSidebar.vue?vue&type=template&id=62716552"
import script from "./WaSidebar.vue?vue&type=script&lang=js"
export * from "./WaSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__